/*! @pentacode/ui v0.1.0 */
import { t as e } from "./styledElement-DUAqv8gi.js";
import { t } from "./css-build-DcREbovZ.js";
import { t as n } from "./decorateMetadata-BXz2gmG4.js";
import { t as r } from "./decorate-C_HUHFGG.js";
import { LitElement as i, html as a } from "lit";
import { customElement as o, property as s, state as c } from "lit/decorators.js";
// \0lit-plugin:css-sheet:./src/elements/progress/progress.css.js
var l = t(":host{--progress-color:var(--orange);--_progress-color:var(--progress-color);--progress-color-subceeded:var(--red);--progress-color-below:var(--orange);--progress-color-above:var(--green);--progress-color-exceeded:var(--red);--progress-color-fg:var(--_progress-color);--progress-color-bg:color-mix(in oklab, var(--_progress-color) 25%, transparent);border-radius:var(--border-radius);text-align:center;font-weight:700;font-size:inherit;border:solid 1px var(--shade-1);background:#fafafa;display:block;position:relative;overflow:hidden}:host([threshold=subceeded]){--_progress-color:var(--progress-color-subceeded)}:host([threshold=subceeded]) [part=numbers]{color:var(--progress-color-fg)}:host([threshold=below]){--_progress-color:var(--progress-color-below)}:host([threshold=above]){--_progress-color:var(--progress-color-above)}:host([threshold=exceeded]){--_progress-color:var(--progress-color-exceeded)}[part=numbers]{box-sizing:border-box;font-variant-numeric:tabular-nums;padding:.2em}[part=progress]{position:absolute;inset:0;overflow:hidden}[part=numbers]{clip-path:rect(0 100% 100% calc(max(0, var(--_progress-amount,0)) * 100%));white-space:nowrap;transition:clip-path .4s}@media (prefers-reduced-motion:reduce){[part=numbers]{transition:none}}[part=progress] [part=numbers]{width:100%;clip-path:rect(0 calc(max(0, var(--_progress-amount,0)) * 100%) 100% 0);color:var(--progress-color-fg);background:var(--progress-color-bg)}");
// src/elements/progress/progress.ts
function u(e) {
	return Intl.NumberFormat("de-DE", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	}).format(e);
}
var d = .05, f = .95, p = 0;
function m(e, t, n) {
	return t <= e && e <= n;
}
function h({ current: e, tolerance: t, min: n, max: r }) {
	return e < n - t ? "subceeded" : e > r + t ? "exceeded" : m(e, n - t, n + t) ? "below" : m(e, r - t, r + t) ? "above" : "within";
}
function g(e) {
	if (e > 0) {
		if (e < d) return d;
		if (e > f && e < 1) return f;
	}
	return e;
}
var _ = class extends e(i) {
	constructor(...e) {
		super(...e), this.role = "progressbar", this.value = 0, this.min = 0, this.max = 100, this.format = u, this.thresholdLimitTolerance = p, this._relativeProgress = this.value / this.max, this.styles = l;
	}
	willUpdate() {
		this._relativeProgress = this.value / this.max, this.threshold = h({
			current: this._relativeProgress,
			min: this.min / this.max,
			max: this.max / this.max,
			tolerance: this.thresholdLimitTolerance
		});
	}
	render() {
		let { value: e, max: t, _relativeProgress: n } = this, r = a`<div part="numbers" style="--_progress-amount: ${g(n)}">
            ${this.format(e)} / ${this.format(t)}
        </div>`;
		return a`
            <div part="progress">${r}</div>
            ${r}
        `;
	}
};
r([s({
	type: String,
	reflect: !0
}), n("design:type", Object)], _.prototype, "role", void 0), r([s({
	type: Number,
	reflect: !0,
	attribute: "aria-valuenow"
}), n("design:type", Number)], _.prototype, "value", void 0), r([s({
	type: Number,
	reflect: !0,
	attribute: "aria-valuemin"
}), n("design:type", Object)], _.prototype, "min", void 0), r([s({
	type: Number,
	reflect: !0,
	attribute: "aria-valuemax"
}), n("design:type", Object)], _.prototype, "max", void 0), r([s({ attribute: !1 }), n("design:type", Function)], _.prototype, "format", void 0), r([s({ type: Number }), n("design:type", Number)], _.prototype, "thresholdLimitTolerance", void 0), r([s({
	reflect: !0,
	attribute: "threshold"
}), n("design:type", Object)], _.prototype, "threshold", void 0), r([c(), n("design:type", Number)], _.prototype, "_relativeProgress", void 0), _ = r([o("ptc-ui-progress")], _);
var v = _;
export { v as i, g as n, h as r, _ as t };

//# sourceMappingURL=progress-CN1MFpao.js.map